/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import {Row, Col, Box} from 'adminlte-2-react';
import {ReferenciaObligatorios} from '../utils/etiquetaObligatorio/ReferenciaObligatorios';
import {Alert} from '../utils/Alert';
import {log} from '../utils/logs';
import {ButtonWithLoading} from '../utils/ButtonWithLoading';
import Loader from '../utils/Loader';
import {CheckBox} from '../ui/Checkbox';
import {SelectInput} from '../utils/SelectInput';
import {ModalGenerico} from '../ui/ModalGenerico';
import {alertTypes} from '../ui/alert';
import {toTitleCase} from '../utils/utils';
import {Content} from '../ui/Content';
import {PhoneInputV3} from '../ui/PhoneInput/PhoneInputV3';

const queryString = require('query-string');
const {TextInput, knownRegexes} = require('../utils/TextInput');

const getFoundEmpresasText = ({history, foundEmpresas}) => {
  const items = foundEmpresas.searchResultsByTerm.map((item, index) => {
    if (!item?.items?.length) {
      return null;
    }

    return (
      <li key={index} style={{marginBottom: 10}}>
        {toTitleCase(item.term)} ({item.count})
        <ul>
          {item.items.map(empresa => (
            <li key={empresa._id}>{toTitleCase(empresa.nombre)}</li>
          ))}
        </ul>
        <a
          href="javascript:;"
          onClick={() =>
            history.push(
              `/empresas/?busquedaRapida=${item.term}&esCliente=TODOS`,
            )
          }>
          Ver más
        </a>
      </li>
    );
  });

  return (
    <>
      <ul>{items}</ul>
    </>
  );
};

function CrearEmpresaView({
  mode,
  history,
  match,
  modelCreateEmpresa,
  submit,
  submitAlert,
  topAlert,
  modelGetEmpresa,
  nombre,
  setNombre,
  direccion,
  setDireccion,
  telefono,
  setTelefono,
  correo,
  setCorreo,
  razonSocial,
  setRazonSocial,
  documento,
  setDocumento,
  gerenteGral,
  setGerenteGral,
  gerenteGralTelefono,
  setGerenteGralTelefono,
  gerenteGralEmail,
  setGerenteGralEmail,
  gerenteRrhh,
  setGerenteRrhh,
  gerenteRrhhTelefono,
  setGerenteRrhhTelefono,
  gerenteRrhhEmail,
  setGerenteRrhhEmail,
  esCliente,
  setEsCliente,
  esGrupo,
  setEsGrupo,
  contactoNombre,
  setContactoNombre,
  contactoTelefono,
  setContactoTelefono,
  rubroOption,
  rubrosOptions,
  setRubroOption,
  grupoEmpresarialOptions,
  grupoEmpresarialOption,
  setGrupoEmpresarialOption,
  empresaId,
  empresaNombreOriginal,
  empresaLoadStatus,
  modalRedirect,
  setModalRedirect,
  foundEmpresas,
  modelSearchEmpresasByName,
  director,
  setDirector,
  directorTelefono,
  setDirectorTelefono,
  directorEmail,
  setDirectorEmail,
  cargoOption,
  cargosOptions,
  setCargoOption,
  emailContacto,
  setEmailContacto,
  contactoNombreServicio,
  setContactoNombreServicio,
  contactoTelefonoServicio,
  setContactoTelefonoServicio,
  cargoOptionServicio,
  setCargoOptionServicio,
  emailContactoServicio,
  setEmailContactoServicio,
  gerenteComercial,
  setGerenteComercial,
  gerenteComercialTelefono,
  setGerenteComercialTelefono,
  gerenteComercialEmail,
  setGerenteComercialEmail,
  readOnly,
  setReadOnly,
}) {
  const title = mode === 'edit' ? 'Editar empresa' : 'Crear empresa';

  return (
    <Content title={title} history={history}>
      {topAlert.text && (
        <Alert
          title={topAlert.title}
          type={topAlert.type}
          text={topAlert.text}
          closable={topAlert.closable}
        />
      )}

      {modalRedirect && (
        <ModalGenerico
          isModalShown={!!modalRedirect}
          hideModal={() => setModalRedirect(null)}
          title="Alerta"
          body="Si no guardaste los cambios hechos en el formulario, se perderán. ¿Continuar?"
          buttonText="Continuar"
          submit={() => {
            history.push(modalRedirect);
          }}
        />
      )}

      <Loader
        isLoading={
          mode === 'edit' &&
          (modelGetEmpresa.loading || empresaLoadStatus !== 'LOADED')
        }>
        <Row>
          <Col md="10" mdOffset="1">
            <Box
              title={`Empresa: ${nombre}`}
              customOptions={
                mode === 'edit' && (
                  <div>
                    <ButtonWithLoading
                      size="sm"
                      type="default"
                      text={readOnly ? 'Editar' : 'Resumen'}
                      submit={() => {
                        setReadOnly(!readOnly);
                      }}
                    />
                    <ButtonWithLoading
                      size="sm"
                      type="default"
                      text="Candidatos"
                      submit={() => {
                        const strQueryParams = queryString.stringify({
                          empresaIdNumerico: empresaId,
                          empresaNombre: empresaNombreOriginal,
                        });
                        return setModalRedirect(
                          `/candidatos/?${strQueryParams}`,
                        );
                      }}
                    />
                    <ButtonWithLoading
                      size="sm"
                      type="default"
                      text="Oportunidades"
                      submit={() => {
                        const strQueryParams = queryString.stringify({
                          empresaIdNumerico: empresaId,
                          empresaNombre: empresaNombreOriginal,
                        });
                        return setModalRedirect(
                          `/oportunidades/?${strQueryParams}`,
                        );
                      }}
                    />
                  </div>
                )
              }>
              <Loader isLoading={modelSearchEmpresasByName?.loading}>
                {foundEmpresas?.total > 0 && (
                  <Alert
                    title={'Se encontraron empresas similares'}
                    type={alertTypes.warning}
                    text={getFoundEmpresasText({foundEmpresas, history})}
                    closable={false}
                  />
                )}
              </Loader>

              {readOnly ? (
                <>
                  <Col md="12">
                    <h4>
                      <strong>Datos principales</strong>
                    </h4>

                    <Col md="4">
                      <h5>
                        <strong>Es cliente: </strong> {esCliente ? 'Si' : 'No'}
                      </h5>
                      <h5>
                        <strong>Telefono: </strong>
                        {telefono}
                      </h5>
                      <h5>
                        <strong>Documento: </strong>
                        {documento}
                      </h5>
                    </Col>
                    <Col md="4">
                      <h5>
                        <strong>Es grupo empresarial: </strong>{' '}
                        {esGrupo ? 'Si' : 'No'}
                      </h5>
                      <h5>
                        <strong>Correo: </strong>
                        {correo}
                      </h5>
                      <h5>
                        <strong>Rubro: </strong>
                        {rubroOption?.label}
                      </h5>
                    </Col>

                    <Col md="4">
                      <h5>
                        <strong>Grupo empresarial: </strong>{' '}
                        {grupoEmpresarialOption?.label}
                      </h5>

                      <h5>
                        <strong>Razón social: </strong>
                        {razonSocial}
                      </h5>

                      <h5>
                        <strong>Dirección: </strong>
                        {direccion}
                      </h5>
                    </Col>
                  </Col>

                  <Col md="12">
                    <h4>
                      <strong>Directores y gerentes</strong>
                    </h4>

                    <Row style={{marginLeft: 3}}>
                      <Col md="4">
                        <h5 style={{}}>
                          <strong>Director: </strong>
                          {director}
                        </h5>
                      </Col>

                      <Col md="4">
                        <h5>
                          <strong>Teléfono: </strong>
                          {directorTelefono}
                        </h5>
                      </Col>

                      <Col md="4">
                        <h5>
                          <strong>Email: </strong>
                          {directorEmail}
                        </h5>
                      </Col>
                    </Row>

                    <Row style={{marginLeft: 3}}>
                      <Col md="4">
                        <h5 style={{}}>
                          <strong>Gerente RRHH: </strong>
                          {gerenteRrhh}
                        </h5>
                      </Col>

                      <Col md="4">
                        <h5>
                          <strong>Teléfono: </strong>
                          {gerenteRrhhTelefono}
                        </h5>
                      </Col>

                      <Col md="4">
                        <h5>
                          <strong>Email: </strong>
                          {gerenteRrhhEmail}
                        </h5>
                      </Col>
                    </Row>

                    <Row style={{marginLeft: 3}}>
                      <Col md="4">
                        <h5 style={{}}>
                          <strong>Gerente general: </strong>
                          {gerenteGral}
                        </h5>
                      </Col>

                      <Col md="4">
                        <h5>
                          <strong>Teléfono: </strong>
                          {gerenteGralTelefono}
                        </h5>
                      </Col>

                      <Col md="4">
                        <h5>
                          <strong>Email: </strong>
                          {gerenteGralEmail}
                        </h5>
                      </Col>
                    </Row>

                    <Row style={{marginLeft: 3}}>
                      <Col md="4">
                        <h5 style={{}}>
                          <strong>Gerente comercial: </strong>
                          {gerenteComercial}
                        </h5>
                      </Col>

                      <Col md="4">
                        <h5>
                          <strong>Teléfono: </strong>
                          {gerenteComercialTelefono}
                        </h5>
                      </Col>

                      <Col md="4">
                        <h5>
                          <strong>Email: </strong>
                          {gerenteComercialEmail}
                        </h5>
                      </Col>
                    </Row>
                  </Col>

                  <Col md="12">
                    <h4>
                      <strong>Contacto administrativo</strong>
                    </h4>
                    <Col md="4">
                      <h5>
                        <strong>Nombre: </strong>
                        {contactoNombre}
                      </h5>
                      <h5>
                        <strong>Teléfono: </strong>
                        {contactoTelefono}
                      </h5>
                    </Col>

                    <Col md="4">
                      <h5>
                        <strong>Cargo: </strong>
                        {cargoOption?.label}
                      </h5>
                    </Col>

                    <Col md="4">
                      <h5>
                        <strong>Email: </strong>
                        {emailContacto}
                      </h5>
                    </Col>
                  </Col>

                  <Col md="12">
                    <h4>
                      <strong>Contacto de servicio</strong>
                    </h4>
                    <Col md="4">
                      <h5>
                        <strong>Nombre: </strong>
                        {contactoNombreServicio}
                      </h5>
                      <h5>
                        <strong>Teléfono: </strong>
                        {contactoTelefonoServicio}
                      </h5>
                    </Col>

                    <Col md="4">
                      <h5>
                        <strong>Cargo: </strong>
                        {cargoOptionServicio?.label}
                      </h5>
                    </Col>

                    <Col md="4">
                      <h5>
                        <strong>Email: </strong>
                        {emailContactoServicio}
                      </h5>
                    </Col>
                  </Col>
                  <Col md="12">
                    {submitAlert.text && (
                      <Alert
                        title={submitAlert.title}
                        type={submitAlert.type}
                        text={submitAlert.text}
                        closable={submitAlert.closable}
                      />
                    )}
                  </Col>
                </>
              ) : (
                <>
                  <h4>Datos principales</h4>
                  <ReferenciaObligatorios />
                  <Col md="12">
                    <Col md="3">
                      <CheckBox
                        text="Es cliente"
                        checked={esCliente}
                        onChange={setEsCliente}
                      />
                    </Col>
                    <Col md="3">
                      <CheckBox
                        text="Es grupo empresarial"
                        checked={esGrupo}
                        onChange={setEsGrupo}
                      />
                    </Col>
                  </Col>
                  <Col md="12">
                    <Col md="4">
                      <TextInput
                        label="Nombre"
                        initialValue={nombre}
                        setValue={setNombre}
                        required
                      />

                      <TextInput
                        label="Documento"
                        initialValue={documento}
                        setValue={setDocumento}
                      />

                      <PhoneInputV3
                        required={true}
                        label="Teléfono"
                        value={telefono}
                        setValue={setTelefono}
                      />
                    </Col>

                    <Col md="4">
                      <SelectInput
                        label="Grupo empresarial"
                        value={grupoEmpresarialOption}
                        options={grupoEmpresarialOptions}
                        setValue={setGrupoEmpresarialOption}
                      />
                      <SelectInput
                        label="Rubro"
                        value={rubroOption}
                        options={rubrosOptions}
                        setValue={setRubroOption}
                      />
                      <TextInput
                        label="Dirección"
                        initialValue={direccion}
                        setValue={setDireccion}
                      />
                    </Col>

                    <Col md="4">
                      <TextInput
                        label="Razón social"
                        initialValue={razonSocial}
                        setValue={setRazonSocial}
                      />
                      <TextInput
                        label="Correo"
                        initialValue={correo}
                        setValue={setCorreo}
                      />
                    </Col>
                  </Col>

                  <h4>Directores y gerentes</h4>

                  <Col md="12">
                    <Col md="4">
                      <TextInput
                        label="Director"
                        initialValue={director}
                        setValue={setDirector}
                      />
                    </Col>

                    <Col md="4">
                      <PhoneInputV3
                        label="Teléfono"
                        value={directorTelefono}
                        setValue={setDirectorTelefono}
                      />
                    </Col>

                    <Col md="4">
                      <TextInput
                        label="Email"
                        initialValue={directorEmail}
                        setValue={setDirectorEmail}
                      />
                    </Col>
                  </Col>

                  <Col md="12">
                    <Col md="4">
                      <TextInput
                        label="Gerente RRHH"
                        initialValue={gerenteRrhh}
                        setValue={setGerenteRrhh}
                      />
                    </Col>

                    <Col md="4">
                      <PhoneInputV3
                        label="Teléfono"
                        value={gerenteRrhhTelefono}
                        setValue={setGerenteRrhhTelefono}
                      />
                    </Col>

                    <Col md="4">
                      <TextInput
                        label="Email"
                        initialValue={gerenteRrhhEmail}
                        setValue={setGerenteRrhhEmail}
                      />
                    </Col>
                  </Col>

                  <Col md="12">
                    <Col md="4">
                      <TextInput
                        label="Gerente general"
                        initialValue={gerenteGral}
                        setValue={setGerenteGral}
                      />
                    </Col>

                    <Col md="4">
                      <PhoneInputV3
                        label="Teléfono"
                        value={gerenteGralTelefono}
                        setValue={setGerenteGralTelefono}
                      />
                    </Col>

                    <Col md="4">
                      <TextInput
                        label="Email"
                        initialValue={gerenteGralEmail}
                        setValue={setGerenteGralEmail}
                      />
                    </Col>
                  </Col>

                  <Col md="12">
                    <Col md="4">
                      <TextInput
                        label="Gerente comercial"
                        initialValue={gerenteComercial}
                        setValue={setGerenteComercial}
                      />
                    </Col>

                    <Col md="4">
                      <PhoneInputV3
                        label="Teléfono"
                        value={gerenteComercialTelefono}
                        setValue={setGerenteComercialTelefono}
                      />
                    </Col>

                    <Col md="4">
                      <TextInput
                        label="Email"
                        initialValue={gerenteComercialEmail}
                        setValue={setGerenteComercialEmail}
                      />
                    </Col>
                  </Col>

                  <h4>Contacto administrativo</h4>
                  <Col md="12">
                    <Col md="4">
                      <TextInput
                        label="Nombre"
                        initialValue={contactoNombre}
                        setValue={setContactoNombre}
                      />

                      <PhoneInputV3
                        required={true}
                        label="Teléfono"
                        value={contactoTelefono}
                        setValue={setContactoTelefono}
                      />
                    </Col>

                    <Col md="4">
                      <SelectInput
                        label="Cargo"
                        value={cargoOption}
                        options={cargosOptions}
                        setValue={setCargoOption}
                        required
                      />
                    </Col>

                    <Col md="4">
                      <TextInput
                        label="Email"
                        initialValue={emailContacto}
                        setValue={setEmailContacto}
                      />
                    </Col>
                  </Col>
                  <h4>Contacto de servicio</h4>
                  <Col md="12">
                    <Col md="4">
                      <TextInput
                        label="Nombre"
                        initialValue={contactoNombreServicio}
                        setValue={setContactoNombreServicio}
                      />

                      <PhoneInputV3
                        required={true}
                        label="Teléfono"
                        value={contactoTelefonoServicio}
                        setValue={setContactoTelefonoServicio}
                      />
                    </Col>

                    <Col md="4">
                      <SelectInput
                        label="Cargo"
                        value={cargoOptionServicio}
                        options={cargosOptions}
                        setValue={setCargoOptionServicio}
                        required
                      />
                    </Col>

                    <Col md="4">
                      <TextInput
                        label="Email"
                        initialValue={emailContactoServicio}
                        setValue={setEmailContactoServicio}
                      />
                    </Col>
                  </Col>
                  <Col md="12">
                    {submitAlert.text && (
                      <Alert
                        title={submitAlert.title}
                        type={submitAlert.type}
                        text={submitAlert.text}
                        closable={submitAlert.closable}
                      />
                    )}
                  </Col>

                  <ButtonWithLoading
                    text="Guardar"
                    submit={submit}
                    loading={modelCreateEmpresa.loading}
                    pullRight
                  />
                </>
              )}
            </Box>
          </Col>
        </Row>
      </Loader>
    </Content>
  );
}

export {CrearEmpresaView};
